import React from 'react';
import styled from 'styled-components';
import { Grid, Typography } from '@material-ui/core';
import { breakpoint } from 'utils/mediaQueries';
import { FormattedMessage } from 'react-intl';

const ContentText = styled(Grid)`
  width: 100%;
  text-align: center;
  margin-top: -3%;
`;
const Subtitle = styled(Typography)`
  ${props => props.conversationalData && 'max-width: 580px;'};
  line-height: 1.25em;
  font-size: ${props => props.theme.typography.h5.fontSize}px;
  ${breakpoint.down('lg')`
  font-size: ${props => `${props.theme.typography.h6.fontSize}
px`};`};
  ${breakpoint.down('md')`
 font-size: ${props => `${props.theme.typography.body1.fontSize}
px`};`};
  ${breakpoint.only('xxs')`
  font-size: ${props => `${props.theme.typography.body1.fontSize}px`};
  `};
`;
const StyledTypography = styled(Typography)`
  padding-top: 1rem;
`;
const TextProblematic = ({ data }) => {
  const conversationalData =
    data.title.frontmatter.useCases === 'conversational_data';
  return (
    <ContentText
      container
      item
      xs={10}
      sm={8}
      md={6}
      lg={5}
      alignItems="center"
      justify="center"
    >
      <Subtitle variant="h1" conversationalData={conversationalData}>
        {data.title.rawMarkdownBody}
      </Subtitle>
      <StyledTypography variant={'body1'}>
        <FormattedMessage id={'useCases.use_case'} />
        <FormattedMessage id={'useCases.' + data.title.frontmatter.useCases} />
      </StyledTypography>
    </ContentText>
  );
};
export default TextProblematic;
